import axios from 'axios';
import { API_URL } from 'config.js';
import { store } from 'store.js';
import { caricamento, aggiornaSchede, caricamentoDettagli, aggiornaDettagliScheda } from 'features/98/schedeTecniche/schedeSlice';
import { aggiornaClienti, aggiornaCurrentCliente } from 'features/global/globalSlice';

const API_SCHEDE_URL = `${API_URL}/98/schedeTecniche/`;
const API_SCHEDE_DETTAGLI_URL = `${API_URL}/98/schedeTecniche/dettagli/`;

const getCurrentCliente = () => {
  const {
    global: { currentCliente },
  } = store.getState();

  return currentCliente || 0;
};

export const richiediDati = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_SCHEDE_URL, { utente, pin });

    const {
      data: { successo, errore, dati },
    } = res;

    const { schede, clienti } = dati;

    if (!successo) {
      store.dispatch(caricamento(false));
      return alert(errore);
    }

    if (successo && schede && clienti) {
      store.dispatch(aggiornaSchede(schede));
      store.dispatch(aggiornaClienti(clienti.sort()));
      if (clienti.indexOf(getCurrentCliente()) === -1) {
        store.dispatch(aggiornaCurrentCliente(clienti[0]));
      }
      store.dispatch(caricamento(false));
    }
  } catch (e) {
    alert('Error while retrieving data. code:v-98-sch-f-50');
  }

  store.dispatch(caricamento(false));
  return true;
};

export const richiediDettagli = async () => {
  store.dispatch(caricamentoDettagli(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
    schede98: { currentScheda },
  } = store.getState();

  const res = await axios.post(API_SCHEDE_DETTAGLI_URL, { utente, pin, idScheda: currentScheda?.IdScheda });

  const {
    data: {
      successo,
      errore,
      dati: { dettagli = [] },
    },
  } = res;

  if (!successo) {
    store.dispatch(caricamentoDettagli(false));
    return alert(errore);
  }

  if (successo && dettagli.length) {
    store.dispatch(aggiornaDettagliScheda(dettagli));
    store.dispatch(caricamentoDettagli(false));
  }

  store.dispatch(caricamentoDettagli(false));
  return true;
};
